import React, { useState, useEffect } from 'react';
import { ServiceBlock } from '../contentdata/ServiceBlock';
import ServiceDescriptions from '../contentdata/ServiceDescriptions';


export const BoxSection = ( { onToggleRAQ } ) => {
    const [currentSection, setCurrentSection] = useState('Commercial');

    // Define default services for each section
    const defaultServices = {
        'Commercial': 'Office and Warehouse LED Lighting',
        'Residential': 'Electrical Panel Upgrades'
    };

    const defaultServiceName = 'Office and Warehouse LED Lighting';
    const defaultServiceDescription = ServiceDescriptions[defaultServiceName];
    const [activeService, setActiveService] = useState({ name: defaultServiceName, description: defaultServiceDescription });

    // Update default service when section changes
    useEffect(() => {
        const defaultName = defaultServices[currentSection];
        const defaultDesc = ServiceDescriptions[defaultName];
        setActiveService({ name: defaultName, description: defaultDesc });
    }, [currentSection]);

    const handleServiceClick = (serviceName) => {
        const serviceDescription = ServiceDescriptions[serviceName];
        setActiveService({ name: serviceName, description: serviceDescription });
    };

    const handleSectionChange = (section) => {
        setCurrentSection(section);
    };

    // Function to determine if a service name is active
    const isActive = (section) => {
        return currentSection === section;
    };

    return (
        <div className='BoxSection'>
            <div className='TopPanel'>
                <h1 className='tp-clm-l'>Services</h1>
                <div className='tp-clm-r'>
                    <ul className='serviceList'>
                        <li className='listItem' onClick={() => handleSectionChange('Commercial')}>
                            <div className='Icon'></div>
                            <p className='serviceName' style={{ fontWeight: isActive('Commercial') ? 'bold' : 'normal' }}>Commercial</p>
                        </li>
                        <li className='listItem' onClick={() => handleSectionChange('Residential')}>
                            <div className='Icon'></div>
                            <p className='serviceName' style={{ fontWeight: isActive('Residential') ? 'bold' : 'normal' }}>Residential</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div className='ContentPanel'>
                {currentSection === 'Commercial' && (
                    <div className='comm-slide'>
                        <div className='clm-one'>
                            <div className='serviceBox'>
                                <p className='sB-h'>{activeService.name}</p>
                                <p className='sB-txt'>{activeService.description}</p>
                            </div>
                        </div>
                        <div className='clm-two'>
                            <h1>Commercial</h1>
                            <div className='serv-container'>
                                {['Office and Warehouse LED Lighting', 'Commercial Electrical Wiring', 'Communications', 'Panel & Sub-panel Replacement and Upgrades'].map(service => (
                                    <ServiceBlock
                                        key={service}
                                        service={service}
                                        onClick={handleServiceClick}
                                        active={activeService.name === service}
                                    />
                                ))}
                            </div>
                            <div className='clm-two-txt'>
                                <p style={{ display: 'none' }}>Nice body of text here explaining the services offered within this category</p>
                                <button className='raqButton' onClick={onToggleRAQ}><span>Request a quote</span></button>
                            </div>
                        </div>
                    </div>
                )}
                {currentSection === 'Residential' && (
                <div className='resi-slide'>
                    <div className='clm-one'>
                        <div className='serviceBox'>
                            <p className='sB-h'>{activeService.name}</p>
                            <p className='sB-txt'>{activeService.description}</p>
                        </div>
                    </div>
                    <div className='clm-two'>
                        <h1>Residential</h1>
                        <div className='serv-container'>
                            {['Electrical Panel Upgrades', 'Electrical Repair Services', 'Indoor Lighting', 'Electrical Vehicle Charger Installation'].map(service => (
                                <ServiceBlock
                                    key={service}
                                    service={service}
                                    onClick={handleServiceClick}
                                    active={activeService.name === service}
                                />
                            ))}
                        </div>
                        <div className='clm-two-txt'>
                            <p style={{ display: 'none' }}>Nice body of text here explaining the services offered within this category</p>
                            <button className='raqButton' onClick={onToggleRAQ}><span>Request a quote</span></button>
                        </div>
                    </div>
                </div>
                )}
            </div>
        </div>
    );
}

export default BoxSection;
